/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';

import {AdnApiClientService} from '../../common/controller/adn-api-client.service';
import {SignalAdminResourceApiBase, SignalAdminResourceModel} from '../../common/controller/signal-admin-resource-api';

export interface NetworkModel extends SignalAdminResourceModel {
  [key: string]: any;
}

@Injectable({providedIn: 'root'})
export class NetworkApiService extends SignalAdminResourceApiBase<NetworkModel> {
  constructor(client: AdnApiClientService) {
    super(client, 'networks');
  }
}
